import {Card, Divider, Row, Steps, Tag, Typography} from "antd";
import { styled } from "styled-components";

export const StyledSteps = styled(Steps)`
    height: 243px;
    .ant-steps-item-process .ant-steps-icon-dot{
        background: var(--secondColor) !important;
    }   
    .ant-steps-item-finish .ant-steps-icon-dot{
        background: var(--secondColor) !important;
    }

`;

